document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const current = gallery.querySelector('[data-gallery-current]');
    let frame;

    const updateStatus = () => {
      if (!track || slides.length < 2) return;
      const index = Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / track.clientWidth)));
      if (current) current.textContent = String(index + 1);
    };

    track?.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(updateStatus);
    }, { passive: true });
    window.addEventListener('resize', updateStatus, { passive: true });
    gallery._mimoGoToMedia = (mediaId) => {
      if (!track || !mediaId) return;
      const targetIndex = slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
      if (targetIndex < 0) return;
      const previousBehavior = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = targetIndex * track.clientWidth;
      updateStatus();
      requestAnimationFrame(() => { track.style.scrollBehavior = previousBehavior; });
    };
    updateStatus();
    gallery._mimoGoToMedia(gallery.dataset.currentVariantMediaId);
  });

  // Promoção: 5 peças ou mais = 50% de desconto em toda a encomenda.
  const BUNDLE_TARGET = 5;
  const getRoot = () => window.Shopify?.routes?.root || '/';
  const formatMoney = (cents) => new Intl.NumberFormat('pt-PT', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'EUR'
  }).format(Number(cents || 0) / 100);

  const buildFilledSlot = (item) => {
    const slot = document.createElement('a');
    slot.className = 'pd-bundle-slot is-filled';
    slot.href = item.url || '#';
    slot.dataset.bundleSlot = '';
    slot.dataset.variantId = String(item.variant_id || '');

    if (item.image) {
      const image = document.createElement('img');
      image.src = item.image;
      image.alt = item.product_title || item.title || '';
      image.loading = 'lazy';
      slot.appendChild(image);
    }

    const title = document.createElement('span');
    title.textContent = String(item.product_title || item.title || '').slice(0, 24);
    const price = document.createElement('strong');
    price.textContent = formatMoney(item.final_price ?? item.price);
    slot.append(title, price);
    return slot;
  };

  const buildEmptySlot = (url) => {
    const slot = document.createElement('a');
    slot.className = 'pd-bundle-slot pd-bundle-slot--empty';
    slot.href = url;
    slot.dataset.bundleBuilderLink = '';
    slot.dataset.bundleSlot = '';
    slot.setAttribute('aria-label', 'Escolher outra peça');

    const plus = document.createElement('span');
    plus.className = 'pd-bundle-slot__plus';
    plus.setAttribute('aria-hidden', 'true');
    plus.textContent = '+';
    const label = document.createElement('small');
    label.textContent = 'Adicionar peça';
    slot.append(plus, label);
    return slot;
  };

  const syncProductBundles = async () => {
    const bundles = [...document.querySelectorAll('[data-bundle]')];
    if (!bundles.length) return;

    try {
      const response = await fetch(`${getRoot()}cart.js`, {
        cache: 'no-store',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error('Não foi possível ler o carrinho.');
      const cart = await response.json();
      const units = [];
      cart.items.forEach((item) => {
        for (let unit = 0; unit < item.quantity && units.length < BUNDLE_TARGET; unit += 1) units.push(item);
      });

      bundles.forEach((bundle) => {
        const slots = bundle.querySelector('[data-bundle-slots]');
        const copy = bundle.querySelector('[data-bundle-copy]');
        const cta = bundle.querySelector('[data-bundle-cta]');
        const builderUrl = bundle.dataset.bundleBuilderUrl || `${getRoot()}collections/all?view=bundle`;
        const total = units.length;
        const missing = Math.max(0, BUNDLE_TARGET - total);

        if (slots) {
          slots.replaceChildren();
          units.forEach((item) => slots.appendChild(buildFilledSlot(item)));
          for (let slot = 0; slot < missing; slot += 1) slots.appendChild(buildEmptySlot(builderUrl));
        }

        if (copy) {
          copy.textContent = total >= BUNDLE_TARGET
            ? 'Já tens 5 ou mais peças no carrinho. A tua encomenda tem 50% de desconto, aplicado automaticamente.'
            : total
              ? `Já tens ${total} de ${BUNDLE_TARGET} peças no carrinho. Com 5 ou mais, a tua encomenda fica com 50% de desconto.`
              : 'Ao levares 5 peças ou mais, a tua encomenda fica com 50% de desconto.';
        }

        if (cta) {
          if (total >= BUNDLE_TARGET) {
            cta.href = '#MimoCart';
            cta.textContent = 'Finalizar encomenda';
            cta.removeAttribute('data-bundle-builder-link');
            cta.dataset.cartToggle = '';
          } else {
            cta.href = builderUrl;
            cta.dataset.bundleBuilderLink = '';
            cta.removeAttribute('data-cart-toggle');
            cta.textContent = total === 0
              ? `Escolher ${BUNDLE_TARGET} peças`
              : `Escolher mais ${missing} ${missing === 1 ? 'peça' : 'peças'}`;
          }
        }
      });
    } catch (requestError) {
      document.querySelectorAll('[data-bundle-error]').forEach((error) => {
        error.textContent = 'Não foi possível sincronizar a oferta com o carrinho. Atualiza a página e tenta novamente.';
      });
    }
  };

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const select = form.querySelector('[data-variant-select]');
    const optionInputs = [...form.querySelectorAll('[data-option-value]')];
    const submit = form.querySelector('[data-product-submit]');
    const stock = form.querySelector('[data-product-stock]');
    const stockLabel = stock?.querySelector('[data-product-stock-label]');
    const syncStock = (state) => {
      if (!stock || !stockLabel) return;
      stock.dataset.state = state;
      stockLabel.textContent = state === 'sold-out' ? 'Fora de stock' : state === 'low' ? 'Últimas unidades em stock' : 'Em stock — pronto para envio';
    };
    const price = document.querySelector('[data-product-price]');
    const comparePrice = document.querySelector('[data-product-compare-price]');
    const gallery = document.querySelector('[data-product-gallery]');
    const variantOptions = [...(select?.options || [])].map((option) => {
      let values = [];
      try { values = JSON.parse(option.dataset.options || '[]'); } catch (error) { values = []; }
      return { option, values };
    });

    const syncSelectedVariant = () => {
      const selectedValues = [];
      optionInputs.forEach((input) => {
        if (input.checked) selectedValues[Number(input.dataset.optionIndex)] = input.value;
      });
      const match = variantOptions.find(({ values }) => values.length === selectedValues.length && values.every((value, index) => value === selectedValues[index]));
      if (!match || !select) { syncStock('sold-out'); return; }

      const variantOption = match.option;
      const isAvailable = variantOption.dataset.available === 'true';
      select.value = variantOption.value;
      syncStock(variantOption.dataset.stockState || 'sold-out');
      if (price) price.textContent = variantOption.dataset.priceFormatted || formatMoney(variantOption.dataset.price);
      if (comparePrice) {
        const onSale = Number(variantOption.dataset.comparePrice) > Number(variantOption.dataset.price);
        comparePrice.hidden = !onSale;
        comparePrice.textContent = onSale ? (variantOption.dataset.comparePriceFormatted || formatMoney(variantOption.dataset.comparePrice)) : '';
      }
      if (submit) {
        submit.disabled = !isAvailable;
        submit.textContent = isAvailable ? 'Adicionar ao carrinho' : 'Esgotado';
      }

      const productUrl = new URL(window.location.href);
      productUrl.searchParams.set('variant', variantOption.value);
      window.history.replaceState({}, '', productUrl.toString());
      gallery?._mimoGoToMedia(variantOption.dataset.mediaId);

      document.querySelectorAll('[data-bundle]').forEach((bundle) => {
        const nextUrl = new URL(bundle.dataset.bundleBuilderUrl || `${getRoot()}collections/all?view=bundle`, window.location.origin);
        nextUrl.searchParams.set('start', variantOption.value);
        bundle.dataset.bundleBuilderUrl = nextUrl.toString();
        bundle.querySelectorAll('[data-bundle-builder-link]').forEach((link) => { link.href = nextUrl.toString(); });
      });
    };

    optionInputs.forEach((input) => input.addEventListener('change', syncSelectedVariant));
  });

  document.addEventListener('mimo:cart:updated', syncProductBundles);
  syncProductBundles();
});
